import { combineReducers } from 'redux'

import commissionsReducer from './commissions/slice'
import emailReducer from './email/slice'
import listingReducer from './listing/slice'
import signonReducer from './signon/slice'
import statusReducer from './status/slice'

export const agencyReducer = combineReducers({
  signon: signonReducer,
  email: emailReducer,
  listing: listingReducer,
  status: statusReducer,
  commissions: commissionsReducer,
})

export type AgencyState = ReturnType<typeof agencyReducer>
